import { InternalAxiosRequestConfig } from 'axios';

export const idempotenceInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers['IdempotenceToken'] ??= crypto.randomUUID();
  return config;
};
